import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, take, tap } from "rxjs";
import { selectIsAuthenticated, selectIsChardiObserver, selectIsCompanyAdmin, selectIsInternalBillingCustomerOnly, selectUser } from "../../store/auth/auth.selectors";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private store = inject(Store);
  private router = inject(Router);
  private isChardiObserver = this.store.selectSignal(selectIsChardiObserver);
  private isCompanyAdmin = this.store.selectSignal(selectIsCompanyAdmin);
  private isInternalBillingCustomerOnly = this.store.selectSignal(selectIsInternalBillingCustomerOnly);
  private authUser = this.store.selectSignal(selectUser);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(selectIsAuthenticated).pipe(
      take(1),
      tap(isAuth => {
        if (!isAuth) {
          this.router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
          return false;
        }
        else {
          const user = this.authUser();
          if (this.isChardiObserver() && !state.url.startsWith('/locations') && !state.url.startsWith('/connectors')) {
            if(user?.userLocations?.length === 1) {
              this.router.navigate(['/locations', user.userLocations[0].locationId]);
            } else {
              this.router.navigate(['/locations']);
            }
          } 
          else if (this.isCompanyAdmin() && !state.url.startsWith('/companies')) {
            this.router.navigate(['/companies', user?.companyId]);
          }
          else if (this.isInternalBillingCustomerOnly() && !state.url.startsWith('/billing/internal/overview')) {
            this.router.navigate(['/billing/internal/overview']);
          }
        }
        return true;
      })
    );
  }
}